// extracted by mini-css-extract-plugin
export default {"card":"styles_card__VLuTd","cardContent":"styles_cardContent__KNm3D"};